{
    "ttl": 365,
    "version": "1.1.0",
    "essential": [
        "JSESSIONID",
        "INSTANCESTICKYSESSIONID",
        "AWSALBAPP-0",
        "AWSALBAPP-1",
        "AWSALBAPP-2",
        "AWSALBAPP-3",
        "AWSALBTG",
        "AWSALBTGCORS"
    ],
    "functional": [
        "UserName",
        "LocaleStr",
        "MaintenancePopupIDs",
        "ServicePopupIDs",
        "Rpt.*_Export"
    ],
    "statistics": [
        "_ga(.*)?",
        "_gid"
    ]
}